var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './badge.styles';
import { classMap } from 'lit/directives/class-map.js';
let PBadge = class PBadge extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'small';
        this.color = 'light-grey';
    }
    static { this.styles = styles; }
    /**
    * Render component
    * @returns {TemplateResult} Template
    */
    render() {
        const classes = {
            [`${this.size}`]: true,
            [`${this.color}`]: true,
        };
        return html ` <div class="badge${classMap(classes)}" role="status"> ${this.color == 'live' ? html `<span class="dot"></span>` : ''}
        <span role="text">
          <slot></slot>
        </span>
      </div>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PBadge.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], PBadge.prototype, "color", void 0);
PBadge = __decorate([
    customElement('p-badge')
    /**
    * PBadge component
    *
    * @class PBadge
    * @typedef {PBadge}
    * @extends {LitElement}
    */
], PBadge);
export { PBadge };
